import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  DollarSign,
  ListChecks,
  Image as ImageIcon,
  MoreHorizontal,
  MessageSquare,
  ShieldCheck,
  Users,
  Settings as SettingsIcon,
  Receipt,
  ShoppingCart,
} from "lucide-react";

const TABS = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard", exact: true },
  { to: "/budget", icon: DollarSign, label: "Budget" },
  { to: "/timeline", icon: ListChecks, label: "Timeline" },
  { to: "/design", icon: ImageIcon, label: "Design" },
];

const MORE_ITEMS = [
  { to: "/invoices", icon: Receipt, label: "Invoices" },
  { to: "/shopping", icon: ShoppingCart, label: "Shopping List" },
  { to: "/feedback", icon: MessageSquare, label: "Feedback" },
  { to: "/permits", icon: ShieldCheck, label: "Permits" },
  { to: "/contractors", icon: Users, label: "Contractors" },
  { to: "/settings", icon: SettingsIcon, label: "Settings" },
];

export default function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* Transparent click-away — no blur, no dim */}
      {moreOpen && (
        <div
          className="md:hidden fixed inset-x-0 top-0 z-[59]"
          style={{ bottom: "var(--bottom-nav-h, 64px)" }}
          onClick={() => setMoreOpen(false)}
        />
      )}

      {/* Vertical popover anchored bottom-right above the nav */}
      {moreOpen && (
        <div
          className="md:hidden fixed right-3 z-[60] rounded-t-xl overflow-hidden shadow-2xl"
          style={{
            bottom: "var(--bottom-nav-h, 64px)",
            minWidth: "160px",
            background: "var(--bg-root)",
            border: "1px solid var(--border-card-base)",
          }}
        >
          {MORE_ITEMS.map(({ to, icon: Icon, label }) => (
            <button
              key={to}
              onClick={() => { navigate(to); setMoreOpen(false); }}
              className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-white/[0.05]"
              style={{ borderBottom: "1px solid var(--border-row)", color: "var(--text-heading)" }}
            >
              <Icon className="w-4 h-4 flex-shrink-0" style={{ color: "var(--text-secondary)" }} />
              <span className="text-sm font-medium">{label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Nav bar */}
      <nav
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-stretch"
        style={{
          height: "var(--bottom-nav-h, 64px)",
          background: "color-mix(in srgb, var(--bg-root) 90%, transparent)",
          borderTop: "1px solid var(--border-card-base)",
          backdropFilter: "blur(12px)",
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
        }}
      >
        {TABS.map(({ to, icon: Icon, label, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className="flex flex-col items-center justify-center gap-1 flex-1 transition-colors"
            style={({ isActive }) => ({
              color: isActive ? "var(--accent-text)" : "var(--text-secondary)",
            })}
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{label}</span>
          </NavLink>
        ))}
        <button
          onClick={() => setMoreOpen((v) => !v)}
          className="flex flex-col items-center justify-center gap-1 flex-1 transition-colors"
          style={{ color: moreOpen ? "rgb(99 102 241)" : "var(--text-secondary)" }}
        >
          <div
            className="flex items-center justify-center w-8 h-6 rounded-full transition-colors"
            style={{ background: moreOpen ? "rgba(99,102,241,0.18)" : "transparent" }}
          >
            <MoreHorizontal className="w-5 h-5" />
          </div>
          <span className="text-[10px] font-medium">More</span>
        </button>
      </nav>
    </>
  );
}
